import { render, staticRenderFns } from "./LoyaltyPage.vue?vue&type=template&id=0c3a7c08&scoped=true"
import script from "./LoyaltyPage.vue?vue&type=script&lang=js"
export * from "./LoyaltyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a7c08",
  null
  
)

export default component.exports